import { transformRecordFromBackend } from "../../utils/transformRecordFromBackend";

/**
 * Applies a parsed realtime SSE payload to list state with optional highlights.
 *
 * @param {Object} params
 * @param {Object} params.payload - Raw SSE payload
 * @param {function(Object): Object|null} params.parsePayload - e.g. parseProjectSsePayload
 * @param {function(Object): Object|undefined} params.getBackendRecord - (parsed) => backend record
 * @param {"project"|"collection"} params.itemType
 * @param {Object|null} params.currentUser
 * @param {function(Object, function(Object): void): void} params.upsertInList
 * @param {function(string[]): void} [params.onTagsDiscovered]
 * @param {function(string, string[], Object, Object, Array): void} [params.scheduleHighlight]
 */
export function handleIncomingRecordUpdate({
  payload,
  parsePayload,
  getBackendRecord,
  itemType,
  currentUser,
  upsertInList,
  onTagsDiscovered,
  scheduleHighlight,
}) {
  const parsedPayload = parsePayload(payload);
  if (!parsedPayload) return;

  const backendRecord = getBackendRecord(parsedPayload);
  if (!backendRecord?.id) return;

  const { changedFields, rawChanges } = parsedPayload;
  const transformed = transformRecordFromBackend(backendRecord, itemType, currentUser);
  if (!transformed?.id) return;

  let previousRecord = null;

  upsertInList(transformed, (previous) => {
    previousRecord = previous;
  });

  if (onTagsDiscovered && transformed.tags?.length > 0) {
    onTagsDiscovered(transformed.tags);
  }

  if (scheduleHighlight && changedFields?.length > 0) {
    scheduleHighlight(
      transformed.id,
      changedFields,
      previousRecord,
      transformed,
      rawChanges
    );
  }

  return transformed;
}
